import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Stack,
  Typography,
  useTheme
} from '@mui/material';
import { IconX } from '@tabler/icons';
import { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import DialogClose from 'views/components/buttons/DialogClose';
import FormContainer from 'views/components/inputs/FormContainer';

const AddDocumentModal = ({
  openModal,
  setOpenModal,
  validationSchema,
  initialValues,
  onFormSubmit,
  handleClick,
  mandatoryDocumentMutation,
  customFormMutation,
  setFile,
  file,
  customForm,
  setCustomForm,
  docId,
  document
}) => {
  const theme = useTheme();
  const intl = useIntl();
  const [visible, setVisible] = useState(initialValues?.isVisible);
  const [mandatory, setMandatory] = useState(initialValues?.isMandatory);
  const [disableUpdate, setDisableUpdate] = useState(true);

  const handleRemoveFile = () => {
    setFile(null);
    setCustomForm(null);
  };

  useEffect(() => {
    if (document) {
      setVisible(document.isVisible);
      setMandatory(document.isMandatory);
    } else {
      setVisible(initialValues?.isVisible);
      setMandatory(initialValues?.isMandatory);
    }
  }, [document, initialValues]);

  useEffect(() => {
    if (document && file) {
      if ((file && document.id !== file.id) || document.isVisible !== visible || document.isMandatory !== mandatory) {
        setDisableUpdate(false);
      } else {
        setDisableUpdate(true);
      }
    }
  }, [document, file, visible, mandatory]);
  console.log(file, customForm);
  return (
    <Dialog open={openModal} maxWidth="sm" fullWidth>
      <DialogTitle>
        {docId ? <FormattedMessage defaultMessage="Update document" /> : <FormattedMessage defaultMessage="Add document from library" />}
      </DialogTitle>
      <DialogClose
        onClose={() => {
          setOpenModal(false);
        }}
      />
      <Divider />
      <DialogContent>
        <FormContainer validation={validationSchema} defaultValues={initialValues} onSuccess={onFormSubmit}>
          <Stack spacing={2} mt={1}>
            <Box sx={{ widht: 100, display: 'flex', alignItems: 'center', gap: 1 }}>
              <Button variant="contained" onClick={handleClick}>
                <FormattedMessage defaultMessage="Upload" />
              </Button>
              {file || customForm ? (
                <Stack
                  key={file?.id || customForm.formId}
                  direction="row"
                  alignItems="center"
                  sx={{
                    borderWidth: 1,
                    borderStyle: 'solid',
                    borderColor: theme.palette.grey[500],
                    borderRadius: theme.shape.borderRadius
                  }}
                >
                  <Typography sx={{ fontSize: 13, pl: 1, maxWidth: 350 }}>{file?.name || customForm.title || customForm.name}</Typography>
                  <IconButton
                    onClick={handleRemoveFile}
                    sx={{
                      m: 0.5,
                      p: 0.4,
                      backgroundColor: '#555',
                      '&:hover': {
                        backgroundColor: '#666'
                      }
                    }}
                  >
                    <IconX style={{ width: 15, height: 15, color: 'white' }} />
                  </IconButton>
                </Stack>
              ) : (
                <Typography>
                  <FormattedMessage defaultMessage="Select document from library." />
                </Typography>
              )}
            </Box>

            {/* <Stack spacing={2} direction={'row'}>
              <Checkbox
                name="isVisible"
                color="primary"
                label={intl.formatMessage({ defaultMessage: 'Show to client on login' })}
                getValue={(value: boolean) => {
                  setVisible(value);
                }}
              />
              <Checkbox
                name="isMandatory"
                color="primary"
                label={
                  customForm
                    ? intl.formatMessage({ defaultMessage: 'Must be completed by the client' })
                    : intl.formatMessage({ defaultMessage: 'Must be accepted by the client' })
                }
                disabled={!visible}
                getValue={(value: boolean) => {
                  setMandatory(value);
                }}
              />
            </Stack> */}
          </Stack>
          <DialogActions sx={{ mt: 3 }}>
            <Button
              variant="contained"
              type="submit"
              sx={{ width: 180 }}
              disabled={mandatoryDocumentMutation.isLoading || customFormMutation.isLoading || (docId && disableUpdate)}
            >
              {docId ? <FormattedMessage defaultMessage="Update" /> : <FormattedMessage defaultMessage="Save" />}
            </Button>
          </DialogActions>
        </FormContainer>
      </DialogContent>
    </Dialog>
  );
};

export default AddDocumentModal;
